export const Header = {
  AUTHORIZATION: 'authorization',
  CACHE: {
    RESPONSE: {
      NAME: 'x-cache-response',
      VALUE: 'service-worker'
    },
    TTL: 'x-cache-ttl',
    EXPIRY: 'x-cache-expiry'
  },
  CONTENT_TYPE: {
    NAME: 'content-type',
    VALUE: {
      JSON: 'application/json',
      TEXT: 'application/text',
      FILES: [
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv'
      ]
    }
  },
  TRANSLATION: {
    NAME: 'accept-language',
    VALUE: {
      DEFAULT: '*'
    }
  },
  IDEMPOTENCY: 'x-idempotency-key',
  MSW: {
    USE: {
      NAME: 'x-use-msw',
      VALUE: 'true'
    },
    X_POWERED_BY: {
      NAME: 'x-powered-by',
      VALUE: 'msw'
    }
  },
  PAGINATION: {
    TOTAL_PAGES: 'x-pagination-totalpages',
    CURRENT_PAGE: 'x-pagination-currentpage',
    ITEMS_PER_PAGE: 'x-pagination-itemsperpage',
    TOTAL_ITEMS: 'x-pagination-totalitems'
  },
  //RETRY_AFTER: 'Retry-After',
  CORRELATION: 'x-correlation-id',
  TRY_WAIT_FOR_RESULT: {
    NAME: 'x-try-wait-for-result',
    VALUE: 'true'
  }
};
